import React, { useState, useEffect } from "react"
import moment from "moment"

const Clock = () => {
  const [date, setDate] = useState(moment().format("ddd, D MMM"))
  const [time, setTime] = useState(moment().format("HH:mm"))

  useEffect(() => {
    setInterval(() => {
      setDate(moment().format("ddd, D MMM"))
      setTime(moment().format("HH:mm"))
    }, 5000)
  }, [])

  return (
    <div className="display-flex-rm margin-left-desktop time-letter-spacing text-align-right text-align-center-mobile white-text">
      <div className="tv-font-xl time">{time}</div>
      <div className="background-pil">
        <div className="tv-font-sm date">{date}</div>
      </div>
      <div className="text-extra-large bold">
        Round may take ~10 minutes to update
      </div>
      {/* super secret versioning. Month and day. */}
      <div className="text-large light-opacity">v11.17</div>
    </div>
  )
}

export default Clock
